export const FIELD_VALIDATION_REQUIRED_ERROR_MESSAGE = 'This field is required'
